<template>
  <b-container fluid>
    <div style="padding-top: 10px">
      <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
        La sezione Monitoraggio fornisce statistiche generali e specifiche sulle adesioni per punto vendita.
      </b-alert>
    </div>
    <b-row class="margin-top-md margin-bottom-md">
      <b-col cols="3">
        <b-card header-bg-variant="light">
          <template #header>
            <div class="custom-card-header">
              <strong>
                <b-icon-funnel></b-icon-funnel>
                Filtri</strong>
            </div>
          </template>
          <b-card-body style="padding: 0.5rem">
            <b-form @submit="retrieveStatistics">
              <b-form-row>
                <b-form-group label="Dalla data" description="Selezionare data inizio" class="col-lg-6 col-md-12">
                  <DatePicker ref="startDate" id="start" v-model="startDate" :required="false"/>
                </b-form-group>

                <b-form-group label="Alla data" description="Selezionare data fine" class="col-lg-6 col-md-12">
                  <DatePicker ref="endDate" id="end" v-model="endDate" :required="false"/>
                </b-form-group>
                <b-form-group label="Filiale" class="col-lg-12 col-md-12">
                  <ShopSelect ref="shop" v-model="shopSelected"/>
                </b-form-group>
                <b-form-group label="Ragione Sociale" description="Selezionare ragione sociale" class="col-lg-12 col-md-12">
                  <b-form-input
                    autocomplete="off"
                    list="company-list"
                    v-model="company"
                  />
                  <datalist id="company-list">
                    <option v-for="item in companies">{{ item.legalName }}</option>
                  </datalist>
                </b-form-group>

              </b-form-row>
              <b-button type="submit" variant="primary" block id="search">
                <b-icon-search/>&nbsp;Cerca
              </b-button>
              <b-button @click="downloadStatsCsv()" variant="success" block :disabled="isDownloadingStats">
                <b-spinner small v-show="isDownloadingStats"></b-spinner>
                <b-icon-download/>&nbsp;Esporta
              </b-button>
            </b-form>
          </b-card-body>
        </b-card>
        <b-card class="margin-top-md" header-bg-variant="light">
          <template #header>
            <div class="custom-card-header">
              <strong>
                <b-icon-bar-chart-line></b-icon-bar-chart-line>
                Generale</strong>
            </div>
          </template>
          <b-card-body style="padding: 0.5rem">
            <b-form>
              <b-list-group>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar variant="primary" icon="file-earmark-arrow-up-fill" class="mr-3"></b-avatar>
                  <span class="mr-auto">Numero di regolamenti del Pregresso da Digitalizzare</span>
                  <b-badge>{{ numberItalianFormat(toDigitalize) }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar variant="success" icon="credit-card-fill" class="mr-3"></b-avatar>
                  <span class="mr-auto">Numero totale di tessere attive attualmente</span>
                  <b-badge>{{ numberItalianFormat(activeBarcodes) }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar variant="info" icon="plus-circle-fill" class="mr-3"></b-avatar>
                  <span class="mr-auto">Numero totale di immissioni</span>
                  <b-badge>{{ numberItalianFormat(generalStats.new) }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar variant="info" icon="arrow-repeat" class="mr-3"></b-avatar>
                  <span class="mr-auto">Numero totale di aggiornamenti</span>
                  <b-badge>{{ numberItalianFormat(generalStats.update) }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar variant="info" icon="arrow-clockwise" class="mr-3"></b-avatar>
                  <span class="mr-auto">Numero totale di riemissioni</span>
                  <b-badge>{{ numberItalianFormat(generalStats.reissue) }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar variant="info" icon="tablet-fill" class="mr-3"></b-avatar>
                  <span class="mr-auto">Numero totale di operazioni da tablet</span>
                  <b-badge>{{ numberItalianFormat(generalStats.cherry) }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar variant="success" icon="file-check-fill" class="mr-3"></b-avatar>
                  <span class="mr-auto">Numero totale di operazioni digitalizzate</span>
                  <b-badge>{{ numberItalianFormat(generalStats.digitalized) }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar variant="primary" icon="list-ul" class="mr-3"></b-avatar>
                  <span class="mr-auto">Numero totale di operazioni</span>
                  <b-badge>{{ numberItalianFormat(generalStats.total) }}</b-badge>
                </b-list-group-item>
              </b-list-group>
            </b-form>
          </b-card-body>
        </b-card>
        <b-card class="margin-top-md" header-bg-variant="light">
          <template #header>
            <div class="custom-card-header">
              <strong>
                <b-icon-archive></b-icon-archive>
                Convenzioni</strong>
            </div>
          </template>
          <b-card-body style="padding: 0.5rem">
            <b-list-group>
              <b-list-group-item class="d-flex flex-column align-items-center">
                <span class="mb-2">
                  Convenzione GNP
                <svg fill="#000000" height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     viewBox="0 0 512 512" xml:space="preserve">
                    <g>
                      <g>
                        <path d="M281.6,51.2H102.4c-14.14,0-25.6,11.46-25.6,25.6v128c0,14.14,11.46,25.6,25.6,25.6h179.2c14.14,0,25.6-11.46,25.6-25.6
                          v-128C307.2,62.66,295.74,51.2,281.6,51.2z M281.6,204.8H102.4v-128h179.2V204.8z"/>
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M402.423,39.697c-6.272-3.021-14.003-0.503-17.126,5.871c-3.098,6.323-0.478,14.003,5.871,17.126
                          c12.297,6.033,27.785,15.505,41.088,26.121c-0.256-0.051-0.657-0.145-0.888-0.196c-7.074-1.476-13.679,3.123-15.053,10.052
                          c-1.374,6.946,3.123,13.679,10.052,15.053c14.942,2.978,31.479,9.83,34.398,14.157c0.008,0.043,0.034,0.077,0.034,0.119v217.6
                          c0,14.123-11.477,25.6-25.6,25.6c-14.123,0-25.6-11.477-25.6-25.6V166.4c0-28.228-22.972-51.2-51.2-51.2V25.6
                          c0-14.14-11.46-25.6-25.6-25.6H51.2C37.06,0,25.6,11.46,25.6,25.6v460.8c0,14.14,11.46,25.6,25.6,25.6h281.6
                          c14.14,0,25.6-11.46,25.6-25.6V140.8c14.123,0,25.6,11.477,25.6,25.6v179.2c0,28.228,22.972,51.2,51.2,51.2s51.2-22.972,51.2-51.2
                          V128C486.4,82.15,411.025,43.904,402.423,39.697z M332.8,486.4H51.2V25.6h281.6V486.4z"/>
                      </g>
                    </g>
                    </svg>
                </span>
                <b-button @click="downloadGNPCsv()" variant="success" block :disabled="isDownloadingGNP">
                  <b-spinner small v-show="isDownloadingGNP"></b-spinner>
                  <b-icon-download />&nbsp;Esporta
                </b-button>
              </b-list-group-item>
            </b-list-group>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="9">
        <b-card header-bg-variant="light">
          <template #header>
            <div class="custom-card-header">
              <strong>
                <b-icon-table></b-icon-table>
                Statistiche</strong>
            </div>
            <div v-show="searched" class="float-right">
              <h6 v-show="!isEmpty(confirmedFilters)" class="filters-list-head">
                Filtri applicati:
                <b-badge class="filter-badge" v-show="confirmedFilters.company" @click="removeFilter('company')" variant="info" pill tag="button">Ragione sociale:
                  <i>{{ confirmedFilters.company }}</i>&nbsp;<b-icon-x-circle-fill
                  variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="confirmedFilters.startDate" @click="removeFilter('startDate')" variant="info" pill tag="button">Data di inizio:
                  <i>{{ asISODate(confirmedFilters.startDate) }}</i>&nbsp;<b-icon-x-circle-fill variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="confirmedFilters.endDate" @click="removeFilter('endDate')" variant="info" pill tag="button">Data di fine:
                  <i>{{ asISODate(confirmedFilters.endDate) }}</i>&nbsp;<b-icon-x-circle-fill variant="light"/>
                </b-badge>
                <b-badge class="filter-badge" v-show="confirmedFilters.shopCode" @click="removeFilter('shopCode')" variant="info" pill tag="button">Ragione sociale:
                  <i>{{ confirmedFilters.shopCode }}</i>&nbsp;<b-icon-x-circle-fill
                    variant="light"/>
                </b-badge>
              </h6>
            </div>
          </template>
          <b-card-body>
            <b-table sticky-header="82vh" :no-border-collapse="true" responsive hover :fields="fields" :items="items">
              <template #cell(action)="row">
                <b-button-group class="mr-2">
                  <b-button variant="info" v-show="row.index !== items.length" size="sm" @click="row.toggleDetails" >
                    <b-icon v-bind:icon="row.detailsShowing ? 'eye-slash-fill' : 'eye-fill'" aria-hidden="true"></b-icon>
                  </b-button>
                </b-button-group>
              </template>
              <template #row-details="row">
                <div class="mt-3">
                  <b-card-group deck>
                    <b-card border-variant="info" header="Provenienza" align="center">
                      <b-row class="mb-2 ml-2 mt-2">
                        <b-col sm="6" class="text-sm-left"><b>Tablet:</b></b-col>
                        <b-col>{{ row.item.cherry }}</b-col>
                      </b-row>

                      <b-row class="mb-2 ml-2">
                        <b-col sm="6" class="text-sm-left"><b>Conad WebApp:</b></b-col>
                        <b-col>{{ row.item.conad }}</b-col>
                      </b-row>

                      <b-row class="mb-2 ml-2">
                        <b-col sm="6" class="text-sm-left"><b>Nuova Digitalizzazione:</b></b-col>
                        <b-col>{{ row.item.newDigitalization }}</b-col>
                      </b-row>

                      <b-row class="mb-2 ml-2">
                        <b-col sm="6" class="text-sm-left"><b>Digitalizzazione del pregresso:</b></b-col>
                        <b-col>{{ row.item.prevDigitalization }}</b-col>
                      </b-row>
                    </b-card>
                    <b-card
                      border-variant="warning"
                      header="Ultime adesioni"
                      align="center">
                      <b-row v-for="item in row.item.latestReceived" class="mb-2 ml-2 mt-2">
                        <b-col sm="6">
                          <span v-if="dataEntryModeShowPill(item.source)" :class="dataEntryModeStyle(item.source)">{{ dataEntryMode(item.source) }}</span>
                        </b-col>
                        <b-col class="text-sm-left"><b>{{ localFormat(item.at) }}</b></b-col>
                      </b-row>
                      <template #footer>
                        <small class="text-muted">Data ultima operazione con dispositivo android: {{ row.item.lastDeviceActivityAt }}</small>
                      </template>
                    </b-card>
                  </b-card-group>
                </div>
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div style="float: right">
      <p style="font-size: 11px">Powered by <img width="100px" src="../assets/CherryChainLogo.png" alt="CherryChain"></img></p>
    </div>
  </b-container>
</template>

<script>
import MembershipApi from "../api/MembershipApi";
import BarcodeApi from "../api/BarcodesApi";
import moment from "moment";
import DatePicker from '@/components/DatePicker'
import ShopsApi from "../api/ShopsApi";
import Style from "@/Style";
import Translate from "@/Translate";
import ShopSelect from "../components/ShopSelect.vue";
import eventBus from "@/EventBus";
import SelfScanningApi from "@/api/SelfScanningApi";

export default {
  name: 'Monitoring',
  components: {ShopSelect, DatePicker},
  provide() {
    return {parentValidator: this.$validator}
  },
  data() {
    return {
      fields: [
        {key: 'name', label: 'Filiale', sortable: true},
        {key: 'new', label: 'Immissioni', sortable: true},
        {key: 'update', label: 'Aggiornamento', sortable: true},
        {key: 'reissue', label: 'Riemissione', sortable: true},
        {key: 'total', label: 'Totale', sortable: true},
        {key: 'tablet', label: 'Totale Tablet', sortable: true},
        {key: 'active', label: 'Tessere Attive', sortable: true},
        {key: 'latestReceivedAt', label: 'Data ultima operazione', sortable: true},
        {key: 'deviceActivationAt', label: 'Data attivazione dispositivo android', sortable: true},
        {key: 'action', label: ''}
      ],
      showAlert: false,
      items: [],
      startDate: null,
      endDate: null,
      shopSelected: null,
      vatCode: null,
      shops: [],
      companies: [],
      toDigitalize: null,
      activeBarcodes: null,
      company: null,
      confirmedFilters: {},
      searched: false,
      generalStats: null,
      isDownloadingStats: false,
      isDownloadingGNP: false,
    }
  },
  mounted() {
    eventBus.$on("show-alert", () => this.showAlert = true)
    this.retrieveActiveBarcodes()
    this.retrieveStatistics()
    this.retrieveCompanies()
  },
  methods: {
    retrieveCompanies() {
      ShopsApi.findCompanies().then(result => this.companies = result)
    },
    retrieveActiveBarcodes() {
      let shopCode = this.shopSelected ? this.shopSelected.code : null
      BarcodeApi.countAllActive({startDate: this.startDate, endDate: this.endDate, vatCode: this.vatCode, shopCode: shopCode})
        .then(result => this.activeBarcodes = result.count)
    },
    retrieveStatistics(event) {
      if (event) event.preventDefault()

      let company = this.companies.find(item => item.legalName.trimEnd() === this.company)
      if (company) this.confirmedFilters.company = company.legalName
      if (this.startDate) this.confirmedFilters.startDate = this.startDate
      if (this.endDate) this.confirmedFilters.endDate = this.endDate
      if (this.shopSelected) this.confirmedFilters.shopCode = this.shopSelected.code
      let shopCode = this.shopSelected ? this.shopSelected.code : null
      this.vatCode = company ? company.vatCode : null

      MembershipApi
      .statistics({startDate: this.startDate, endDate: this.endDate, vatCode: this.vatCode, shopCode: shopCode})
      .then(result => {
        this.toDigitalize = result.data.toDigitalize
        this.items = result.data.stats.map((statistic) => {
          let item = {}
          let latestReceivedAt = statistic.latestReceived.length !== 0 ? moment.utc(statistic.latestReceived[0].at).local().format("DD/MM/YYYY HH:mm") : ""
          let deviceActivationAt = statistic.deviceActivationAt ? moment.utc(statistic.deviceActivationAt).local().format("DD/MM/YYYY") : ""
          item.new = statistic.new
          item.update = statistic.update
          item.reissue = statistic.reissue
          item.cherry = statistic.source.cherry
          item.conad = statistic.source.conad
          item.active = statistic.active
          item.newDigitalization = statistic.source.newDigitalization
          item.prevDigitalization = statistic.source.prevDigitalization
          item.latestReceivedAt = latestReceivedAt
          item.latestReceived = statistic.latestReceived
          item.total = item.new + item.update + item.reissue
          item.tablet = statistic.source.cherry
          item.lastDeviceActivityAt = moment.utc(statistic.lastDeviceActivityAt).local().format("DD/MM/YYYY")
          item.deviceActivationAt = deviceActivationAt
          item.name = `${statistic.shopId} - ${statistic.name}`
          return item
        })
        this.items = this.items.sort((firstItem, secondItem) => {
          if (firstItem.total > secondItem.total) return -1
          else if (firstItem.total === secondItem.total) return 0
          else return 1
        })

        this.generalStats = this.items.reduce((a, b) => {
          a.new += b.new
          a.update += b.update
          a.reissue += b.reissue
          a.total += b.total
          a.cherry += b.cherry
          a.digitalized += (b.newDigitalization + b.prevDigitalization)
          return a
        }, {new: 0, update: 0, reissue: 0, total: 0, cherry: 0, digitalized: 0})
      })

      this.retrieveActiveBarcodes()

      this.searched = true
    },
    asISODate: date => moment(date).format('DD/MM/YYYY'),
    localFormat: date => moment.utc(date).local().format("DD/MM/YYYY HH:mm"),
    removeFilter(field) {
      delete this.confirmedFilters[field]

      if (field === 'company') {
        this.company = null
      }
      if (field === 'startDate') {
        this.$refs.startDate.reset()
        this.startDate = null
      }
      if (field === 'endDate') {
        this.$refs.endDate.reset()
        this.endDate = null
      }
      if(field === 'shopCode') {
        this.$refs.shop.reset()
        this.shopSelected = null
      }

      this.retrieveStatistics()
    },
    isEmpty(object) { return Object.keys(object).length === 0},
    dataEntryMode(dataEntryMode) { return Translate.dataEntryMode(dataEntryMode) },
    dataEntryModeStyle(dataEntryMode) { return Style.dataEntryModeStyle(dataEntryMode) },
    dataEntryModeShowPill(dataEntryMode){return Style.showDataEntryModePill(dataEntryMode)},
    numberItalianFormat(number) { return Number(number).toLocaleString("it-IT") },
    downloadStatsCsv() {
      let shopCode = this.shopSelected ? this.shopSelected.code : null

      this.isDownloadingStats = true
      MembershipApi
        .statisticsCsv({startDate: this.startDate, endDate: this.endDate, vatCode: this.vatCode, shopCode: shopCode})
        .finally(() => { this.isDownloadingStats = false })
    },
    downloadGNPCsv(){
      this.isDownloadingGNP = true
      SelfScanningApi
        .downloadGNP()
        .finally(() => { this.isDownloadingGNP = false })
    }
  }
}
</script>

<style scoped>
table { margin-top: 20px; }
</style>
